import React, { useState } from 'react';
import Sidebar from '@/components/Sidebar';
import Header from '@/components/Header';
import AlertNotification from '@/components/AlertNotification';
import { Outlet } from 'react-router-dom';
import Footer from '@/components/Footer';
import MobileFooterBar from '@/components/MobileFooterBar';
import { useGetNotificationsQuery } from '@/store/api/notificationApi';

const HomeLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { data } = useGetNotificationsQuery(
    { type: 'Alert' },
    { pollingInterval: 30000, refetchOnMountOrArgChange: true }
  );
  const hasAlert = (data?.data?.Alert?.length ?? 0) > 0;

  return (
    <div>
      <Header sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
      <AlertNotification />
      <main>
        <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
        <div
          className="lg:ml-[252px] pb-[63.5px] md:pb-0"
          style={{ '--top-offset': hasAlert ? '96px' : '70px' } as React.CSSProperties}
        >
          <Outlet />
          <Footer />
        </div>
      </main>
      <MobileFooterBar />
    </div>
  );
};

export default HomeLayout;
